import { render, staticRenderFns } from "./ProductReviewCard.vue?vue&type=template&id=49f68e50&"
import script from "./ProductReviewCard.vue?vue&type=script&lang=js&"
export * from "./ProductReviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports